import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { GlobalContants, Resource } from 'src/app/constants/global.contants';
import { MaterialModule } from 'src/app/material.module';
import { ApiTitleComponent } from '../../common/api-title/api-title.component';
import { environment } from 'src/environments/environment';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';
import { ApiUIResponseComponent } from '../api-ui-response/api-ui-response.component';
import { HTTPMethod } from 'src/app/constants/enum';
import { apiEndPoints } from 'src/app/constants/api-endpointsconstant';
export interface statusCode {
  key: string;
  value: string;
  required: boolean
}

const Headers: statusCode[] = [
  {
    key: "Content-Type",
    value: 'application/json',
    required: false
  },
  {
    key: "API-KEY",
    value: '{{API-KEY}}',
    required: true
  },
  {
    key: "USER-TOKEN",
    value: '{{USER-TOKEN}}',
    required: true
  }
];
const QueryData: any = [
  {
    param: "lat",
    value: '{{lat}}',
    required: true
  },
  {
    param: "lon",
    value: '{{lon}}',
    required: true
  },
  {
    param: " distance (meter)",
    value: '{{distance}}',
    required: false
  },
  {
    param: "limit",
    value: '{{limit}}',
    required: false
  },
  {
    param: "offset",
    value: '{{offset}}',
    required: false
  },
   {
    param: "filter",
    value: '{{filter}} Filter value in json format e.g.',
    code: `{
  "category": "",
}`
  }

]
@Component({
  selector: 'app-nearby-data',
  standalone: true,
  imports: [CommonModule, MaterialModule, RouterModule, ApiTitleComponent, ApiUIResponseComponent],
  templateUrl: './nearby-data.component.html',
  styleUrl: './nearby-data.component.scss'
})
export class NearbyDataComponent {
  HTTPMethod = HTTPMethod;
  displayedColumns: string[] = ['key', 'value', 'required'];
  QueryColumns: string[] = ['param', 'value', 'required'];
  dataSource = Headers;
  QueryDataSource = QueryData;

  api_ui: boolean = false;

  GlobalContants = GlobalContants
  constructor(private sharedService: SharedService,
    private userService: UserService,
    private router: Router) {

  }

  ngOnInit() {
    let userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.userService.getAllUserResource(userInfo.user_id)
      .subscribe({
        next: (res: any) => {
          const matched = res.data.find((r: any) => r.resource_name === Resource.nearby);
          if (!matched?.methods?.includes(HTTPMethod.GET)) {
            this.router.navigate(['/'])
          }
        },
        error: (err) => {
        }
      })
  }

  ngAfterViewInit() {

  }

  api_demo = `${environment.apiBaseUrl}${apiEndPoints.nearby}`;

  api_response = `{
  "status": 0,
  "message": "string",
  "data": {
    "property_uid": "string",
    "property_name": "string",
    "property_category": "string",
    "distance": 0,
    "parcel_no": "string",
    "paci_no": "string",
    "parcel_uid": "string",
    "neigh_name": "string",
    "block_name": "string",
    "lat": "string",
    "lon": "string"
    
  }
}`;

}
